/**
 * @file: 文本框新建
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree/index';
import { StageEvent } from '../../message/index';
import Utils from '../../utils/util';
import NextTick from '../../utils/nextTick';
import Select from '../select/index';
import Add from '../add/index';
import History from '../history/index';
import TextareaTpl from './textareaTpl';

const defaultOptions: TextareaCreateParams = {
    width: 20,
    height: 20,
    content: '文本',
    fontSize: 20
};

async function create(params: TextareaCreateParams = {}): Promise<void> {
    let info: TextareaCreateParams = {
        ...defaultOptions,
        ...params
    };
    let taskQueue: Array<AddTask> = makeAddTaskQueue(info);
    let addCubes: Array<CubeId> = await Add.runAddTaskQueue(taskQueue);

    History.stackIn({
        type: 'add',
        data: addCubes
    });
    Select.addGroup(addCubes);
    Select.panelSelectAsync();
}

function makeAddTaskQueue(params: TextareaCreateParams): Array<AddTask> {
    let result: Array<AddTask> = [];

    result.push({
        type: 'textarea',
        cubeData: TextareaTpl.get(params),
        extendParams: {
            addType: 'normal'
        }
    });

    return result;
}

export {
    create
};
